import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'orders',
    initialState: {orders: [], orders_single: false, message: false},
    reducers:{
        getOrders: (state,action)=>{
            state.orders = action.payload
        },
        getOrder: (state,action)=>{
            state.orders_single = action.payload
        },
        saveOrder: (state,action)=>{
            state.orders.unshift(action.payload)
            state.message = true
        },
        saveDeliveryOrder: (state,action)=>{
            state.message = true
        },
        editOrder: (state,action)=>{
            state.orders_single = false
            state.message = true
        },
        deleteToOrder: (state,action)=>{
            state.orders = state.orders.filter(item=>item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state,action)=>{
            state.message = false
        },
        messageFail: (state,action)=>{
            state.message = 'error'
        }
    }
})

export const getAllOrders = () => apiCall({
    url: 'orders/',
    method: 'GET',
    onSuccess: slice.actions.getOrders.type
})


export const getAllOrdersNotOrdered = () => apiCall({
    url: 'orders/?not_ordered=1',
    method: 'GET',
    onSuccess: slice.actions.getOrders.type
})


export const getOneOrder = (id) => apiCall({
    url: 'orders/'+id,
    method: 'GET',
    onSuccess: slice.actions.getOrder.type,
})

export const editOneOrder = (data) => apiCall({
    url: 'orders/'+data.id+'/',
    method: 'PUT',
    onSuccess: slice.actions.editOrder.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const deliveryOrderSave = (data) => apiCall({
    url: 'delivery/',
    method: 'POST',
    onSuccess: slice.actions.saveDeliveryOrder.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export default slice.reducer
export const {messageReset} = slice.actions